// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1001":"css/admin-app.6949","5504":"css/app.6949"}[chunkId] + ".css";
};